import { useEffect, useRef } from 'react';

// Add MathJax script to document head
const addMathJaxScript = () => {
  if (typeof window !== 'undefined' && !window.MathJax) {
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-svg.js';
    script.async = true;
    document.head.appendChild(script);
  }
};

// Helper to typeset math when MathJax is ready
const typeset = (element: HTMLElement | null) => {
  if (typeof window !== 'undefined' && window.MathJax && element) {
    window.MathJax.typesetClear([element]);
    window.MathJax.typesetPromise([element]);
  }
};

declare global {
  interface Window {
    MathJax: any;
  }
}

export const InlineMath = ({ children }: { children: string }) => {
  const spanRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    addMathJaxScript();
    typeset(spanRef.current);
  }, [children]);

  return (
    <span
      ref={spanRef}
      style={{ color: '#C0C2C5', display: 'inline-flex', alignItems: 'center' }}
    >
      {`\\(${children}\\)`}
    </span>
  );
};

export const BlockMath = ({ children }: { children: string }) => {
  const divRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    addMathJaxScript();
    typeset(divRef.current);
  }, [children]);

  return (
    <div ref={divRef} style={styles.block}>
      {`\\[${children}\\]`}
    </div>
  );
};

const styles = {
  block: {
    color: '#C0C2C5',
    display: 'block',
    margin: '0 0',
    textAlign: 'center',
  },
} as const;
